import {TabulatorFull} from "tabulator-tables";
import $ from "jquery";
import {applyURLQueryParameters, debounce} from "./utils";
export default class RemoteTable extends TabulatorFull {
    constructor(selector, url, columns) {
        super(selector, {
            ajaxURL: url,
            ajaxURLGenerator: (...args) => {return this._generateURL(...args);},
            ajaxResponse: (...args) => {return this._prepareRemoteData(...args);},
            sortMode: 'remote',
            columns: columns,
            placeholder: 'No Records Found',
            layout: 'fitColumns',
            responsiveLayout: 'hide',
            // Without an explicit height, Tabulator decides whether the table is
            // "fixed height" by reading the container's clientHeight at construction
            // time. If that read races the container's CSS/layout settling and comes
            // back as 0, Tabulator falls back to a JS-computed auto-height mode whose
            // resize/redraw dispatch can recurse into itself indefinitely (upstream
            // Tabulator issue, e.g. tabulator-tables#4651) and crash with
            // "Maximum call stack size exceeded". Giving it a real height makes that
            // determination deterministic and keeps the table on the stable
            // CSS-`calc()`-based sizing path instead.
            height: 'calc(100vh - 260px)',
        });
        this.filterParams = {};
    }
    bindFilterButtons($buttons) {
        $buttons.click(event => {
            event.preventDefault();
            const $el = $(event.currentTarget);
            const filterGroup = $el.attr('data-filter');
            const selectedVal = $el.attr('data-value') || null;
            $el.addClass('active');
            // Mark other buttons as inactive
            $(`.btn-filter[data-filter="${filterGroup}"]`).not($el).removeClass('active');
            if (this.filterParams[filterGroup] !== selectedVal) {
                this.filterParams[filterGroup] = selectedVal;
                this.reload();
            }
        });
    }
    bindSearchInput($searchInput) {
        $searchInput.keyup(debounce(600, () => {
            const term = ($searchInput.val() || '').trim() || null;
            if (term !== this.filterParams.search) {
                this.filterParams.search = term;
                this.reload();
            }
        }));
    }
    reload() {
        // setData() always resets the table's scroll position to the top, which is
        // disorienting when reloading after a small change (e.g. a toggle click) deep
        // in a long, scrolled list. replaceData() fetches the same way but keeps the
        // table in its current scroll position instead.
        return this.replaceData();
    }
    _prepareRemoteData(url, params, resp) {
        return resp;
    }
    _getFilterQueryParams() {
        const queryParams = {};
        for (const [key, val] of Object.entries(this.filterParams)) {
            if (val) {
                queryParams[key] = val;
            }
        }
        return queryParams;
    }
    _generateURL(url, config, tabulatorParams) {
        const queryParams = this._getFilterQueryParams();
        // Sort params
        if (Array.isArray(tabulatorParams.sort) && tabulatorParams.sort.length > 0) {
            let orderBy = [];
            tabulatorParams.sort.map(sortData => {
                let prefix = '';
                if (sortData.dir === 'desc') {
                    prefix = '-';
                }
                orderBy.push(`${prefix}${sortData.field}`);
            });
            queryParams.ordering = orderBy.join(',');
        }
        return applyURLQueryParameters(url, queryParams);
    }
}
